import Routes from '../routes/routes'
import { buildGetApi } from './helpers'
import { buildSerZones } from './converters/serZone'

export default buildGetApi({
    route: Routes.apiGetSerZones,
    buildResult: buildSerZones,
    mapParams: ({ townId }) => ({ townId }),
})
